import React from "react";
import deleteIconSrc from "./images/delete-button.svg";

interface ProductCardProps {
  title: string;
  price: string | number;
  totalPrice: string | number;
  description?: string;
  imageUrl: string;
  quantityOptions: number[];
  selectedQuantity: number;
  onQuantityChange: (quantity: number) => void;
  onDelete: () => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  title,
  price,
  totalPrice,
  description,
  imageUrl,
  quantityOptions,
  selectedQuantity,
  onQuantityChange,
  onDelete,
}) => {
  const containerStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "flex-start",
    padding: "20px 15px",
    border: "1px solid #d3d7da",
    borderRadius: "12px",
    backgroundColor: "#fdfcfb",
    fontFamily: "Avenir Next Codensed Regular",
    color: "rgb(52, 39, 20)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
    marginBottom: "20px",
    transition: "all 0.3s ease-in-out",
    gap: "16px",
  };

  const imageStyle: React.CSSProperties = {
    width: "100px",
    height: "100px",
    borderRadius: "8px",
    objectFit: "cover",
    flexShrink: 0,
  };

  const contentStyle: React.CSSProperties = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  };

  const headerStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "10px",
  };

  const titleStyle: React.CSSProperties = {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#514633",
    marginBottom: "4px",
    flex: 1,
  };

  const deleteIconStyle: React.CSSProperties = {
    width: "20px",
    height: "20px",
    cursor: "pointer",
    opacity: 0.7,
    transition: "opacity 0.2s",
  };

  const priceInfoStyle: React.CSSProperties = {
    fontSize: "0.95rem",
    color: "#c39d63",
    fontWeight: 500,
    marginBottom: "8px",
  };

  const descriptionStyle: React.CSSProperties = {
    fontSize: "0.85rem",
    color: "#342714",
    marginBottom: "12px",
  };

  const selectStyle: React.CSSProperties = {
    padding: "6px 12px",
    fontSize: "0.9rem",
    border: "1px solid #d3d7da",
    borderRadius: "6px",
    fontFamily: "inherit",
    width: "80px",
  };

  return (
    <div style={containerStyle}>
      <img src={imageUrl} alt={title} style={imageStyle} />

      <div style={contentStyle}>
        <div style={headerStyle}>
          <div style={titleStyle}>{title}</div>
          <img
            src={deleteIconSrc}
            alt="Entfernen"
            style={deleteIconStyle}
            title="Artikel entfernen"
            onClick={onDelete}
          />
        </div>

        <div style={priceInfoStyle}>
          Einzelpreis: {parseFloat(price.toString()).toFixed(2)} €
        </div>
        <div style={priceInfoStyle}>
          Gesamt: {parseFloat(totalPrice.toString()).toFixed(2)} €
        </div>

        {description && (
          <div style={descriptionStyle}>
            {description.length > 90 ? description.slice(0, 90) + "…" : description}
          </div>
        )}

        <div>
          <select
            value={selectedQuantity}
            onChange={(e) => onQuantityChange(parseInt(e.target.value))}
            style={selectStyle}
          >
            {quantityOptions.map((qty) => (
              <option key={qty} value={qty}>
                {qty} Stk.
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;